/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BitcoinLightning: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M14.8486 2.15132C15.2284 1.78565 15.8662 2.13706 15.7314 2.63764L13.7568 9.96968H18.9433C19.8826 9.96968 20.3536 11.0635 19.6894 11.7031L9.15135 21.8486C8.77158 22.2143 8.13376 21.8628 8.26854 21.3623L10.2432 14.0302H5.05663C4.11732 14.0302 3.64635 12.9364 4.31053 12.2968L14.8486 2.15132Z'
      fill='currentColor'
    />
  </React.Fragment>
)
